import { useState, useEffect } from 'react';
import { editDietInfo } from './index';
import { useNotify } from "react-admin";
import { SalesApiData } from './SaleApiData';
import { TextField, List, ListItem, ListItemText, Button, Switch, FormControlLabel, FormGroup, Select, MenuItem, FormControl, InputLabel, Badge, Checkbox, CircularProgress } from '@material-ui/core';
export function DietInfo(props: any) {
    let allDietTypes = props.allDietTypes;
    let { id, sid, beforeId, dietNumber, firstMultiDietId, fileNumber, dietType, dietCount, hamiPackageCount, isReady, submitDate, issueDate, packageDietCount, referTimes, isActive , saleApiRequestData , saleApiRequestId} = props.diet
    let isEdit = props.isEdit;
    let issaleApiStates = props.issaleApiStates
    let refetchChild = props.refetchChild;
    let switchIsEdit = props.switchIsEdit;
    let [values, setValues] = useState<any>({
        dietId: id,
        dietType: Object.keys(allDietTypes).find(key => allDietTypes[key] === dietType) || '',
        dietNumber:dietNumber || null,
        fileNumber:fileNumber || null,
        dietCount: dietCount || null,
        hamiPackageCount: hamiPackageCount || null,
        packageDietCount: packageDietCount || null,
        firstMultiDietId: firstMultiDietId || null,
        referTimes: referTimes || null,
        beforeId: beforeId || null,
        isActive: isActive || null,
    });
    let [isLoading, setIsLoading] = useState<any>(false);
    const notify = useNotify()
    let [isArchived, setIsArchived] = useState<any>(false);

    useEffect(() => {
        resetState();
        checkIsArchive()
    }, [props]);
    const checkIsArchive = () => {
        sid && sid.endsWith("-old") ? setIsArchived(true) : setIsArchived(false)
    }
    const checkTab = ()=>{
        if (!isEdit && !issaleApiStates) {
            return '1'
        }
        if (issaleApiStates) {
            return '2'
        }
        if (isEdit) {
            return '3'
        }
    }
    const resetState = () => {
        setValues({
            dietId: id,
            dietType: Object.keys(allDietTypes).find(key => allDietTypes[key] === dietType) || '',
            dietCount: dietCount || null,
            dietNumber:dietNumber || null,
            fileNumber:fileNumber || null,
            hamiPackageCount: hamiPackageCount || null,
            packageDietCount: packageDietCount || null,
            firstMultiDietId: firstMultiDietId || null,
            referTimes: referTimes || null,
            beforeId: beforeId || null,
            isActive: isActive || null,
        })


    }

    submitDate === null ? submitDate = null : submitDate = new Date(submitDate);
    issueDate === null ? issueDate = null : issueDate = new Date(issueDate);
    const submitEdit = async (e: any) => {
        setIsLoading(true)
        e.preventDefault()
        try {
            let payload: any = {
                dietId: values.dietId,
            };
            if (values.dietCount !== dietCount) {
                payload.dietCount = values.dietCount;
            }
            if (values.isActive !== isActive) {
                payload.isActive = values.isActive;
            }
            if (values.hamiPackageCount !== hamiPackageCount) {
                payload.hamiPackageCount = values.hamiPackageCount;
            }
            if (values.packageDietCount !== packageDietCount) {
                payload.packageDietCount = values.packageDietCount;
            }
            if (values.referTimes !== referTimes) {
                payload.referTimes = values.referTimes;
            }
            if (values.dietType !== dietType) {
                payload.dietType = values.dietType;
            }
            if (values.dietNumber !== dietNumber) {
                payload.dietNumber = values.dietNumber;
            }
            if (values.fileNumber !== fileNumber) {
                payload.fileNumber = values.fileNumber;
            }
            if (values.firstMultiDietId !== firstMultiDietId) {
                payload.firstMultiDietId = values.firstMultiDietId;
                if (values.firstMultiDietId === null || values.firstMultiDietId === '') {
                    payload.firstMultiDietId = 0;
                }
            }
            if (values.beforeId !== beforeId) {
                payload.beforeId = values.beforeId;
                if (values.beforeId === null || values.beforeId === '') {
                    payload.beforeId = 0;
                }
            }
            const response = await editDietInfo(payload)
            if (response.data && response.data.err) {
                notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
                setIsLoading(false)
                switchIsEdit()

            } else {
                notify(`تغییرات با موفقیت ثبت شد`)
                setIsLoading(false)
                switchIsEdit()
                refetchChild()
                resetState()
            }
        } catch (error) {
            notify(`خطایی پیش آمده است`)
            setIsLoading(false)
            switchIsEdit()
        }


        ;

    }
    const onChangeSelect = (e: any) => {
        setValues({ ...values, dietType: e.target.value })
    }
    return (
        <div style={{
            fontFamily: "IranSans-Medium",
            fontSize: "12px",
            display: "flex",
            flexDirection: "column",
            border: "1px solid #d2d2d2",
            borderTop: "none",
            padding: "5px",
            width: "90%",
            height: "550px",
            background: isArchived ? "#9e9e9e" : "#e7e7e7",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px"
        }}>
            <Badge
                style={{ fontFamily: "IranSans-Light", fontSize: "11px" }}
                invisible={!isArchived}
                color="secondary"
                badgeContent=" آرشیو  "
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >

            </Badge>
            {checkTab() === '1' ?
                <div style={{borderTop:"5px solid white"}}>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "2px", fontWeight: "700" }}>شناسه :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{id ? id : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> شناسه یکتا :</span>  <span style={{ margin: "2px", color: "#616161" }}>{sid ? sid : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> رژیم قبلی  :</span>  <span style={{ margin: "2px", color: "#616161" }}>{beforeId ? beforeId : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> شماره رژیم  :</span>  <span style={{ margin: "2px", color: "#616161" }}>{dietNumber ? dietNumber : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}>شماره پرونده  :</span>  <span style={{ margin: "2px", color: "#616161" }}>{fileNumber ? fileNumber : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> فعال   :</span>  <span style={{ margin: "2px", color: "#616161" }}>{isActive === true ? "فعال" : ''}{isActive === false ? "غیرفعال" : ''}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> آماده   :</span>  <span style={{ margin: "2px", color: "#616161" }}>{isReady === true ? "فعال" : ''}{isReady === false ? "غیرفعال" : ''}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}>تاریخ ارسال به سیب دايت  :</span>  <span style={{ margin: "2px", color: "#616161" }}>{submitDate && submitDate !== null ? submitDate.toLocaleString('fa') : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}>تاریخ صدور رژیم :</span>  <span style={{ margin: "2px", color: "#616161" }}>{issueDate && issueDate !== null ? issueDate.toLocaleString('fa') : '-'}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> نوع رژیم :</span> <span style={{ margin: "2px", color: "#616161" }}>{dietType ? dietType : '-'}</span> </div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> شماره رژیم در بسته  :</span> <span style={{ margin: "2px", color: "#616161" }}>{dietCount ? dietCount : ''}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}> تعداد لیمو پلاس بسته  :</span> <span style={{ margin: "2px", color: "#616161" }}>{hamiPackageCount ? hamiPackageCount : ''}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}>   تعداد رژیم بسته  :</span> <span style={{ margin: "2px", color: "#616161" }}>{packageDietCount ? packageDietCount : ''}</span></div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}>  شناسه رژیم اول بسته :</span><span style={{ margin: "2px", color: "#616161" }}>{firstMultiDietId ? firstMultiDietId : '-'}</span> </div>
                    <div style={{ marginTop: "2px", borderRight: "4px solid #d2d2d2", paddingRight: "2px" }}><span style={{ margin: "4px", fontWeight: "700" }}>   تعداد مراجعه        :</span><span style={{ margin: "2px", color: "#616161" }}>{referTimes ? referTimes : '-'}</span> </div>

                </div>
                : <div></div>}
            {checkTab() === '2' ? <SalesApiData saleApiRequestData={saleApiRequestData} saleApiRequestId={saleApiRequestId} />: <div></div> }
            {checkTab() === '3' ?
                <div>
                    <form action="" onSubmit={(e) => submitEdit(e)}>
                        <FormControl style={{ fontFamily: "IranSans-Light", width: "100%" }}>
                            <InputLabel id="demo-simple-select-label">نوع رژیم</InputLabel>
                            <Select
                                style={{ fontFamily: "IranSans-Light" }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                variant='filled'
                                value={values.dietType}
                                onChange={(e) => onChangeSelect(e)}
                            >
                                {Object.keys(allDietTypes).map((key: string) => (
                                    <MenuItem key={key} value={key}>{allDietTypes[key]}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, dietCount: e.target.value })}
                            value={values.dietCount}
                            label=" شماره رژیم در بسته"
                            size="small"
                            variant="filled"
                            focused>

                        </TextField>
                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, beforeId: e.target.value })}
                            value={values.beforeId}
                            label="  رژیم  قبلی"
                            focused
                            size="small"
                            variant="filled">

                        </TextField>
                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, fileNumber: e.target.value })}
                            value={values.fileNumber}
                            label="    شماره پرونده"
                            focused
                            size="small"
                            variant="filled">

                        </TextField>
                                      <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, dietNumber: e.target.value })}
                            value={values.dietNumber}
                            label="     شماره رژیم"
                            size="small"
                            focused
                            variant="filled">

                        </TextField>
                        
                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, hamiPackageCount: e.target.value })}
                            value={values.hamiPackageCount}
                            label=" تعداد لیمو پلاس بسته "
                            focused
                            size="small"
                            variant="filled">

                        </TextField>
                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, packageDietCount: e.target.value })}
                            value={values.packageDietCount}
                            label=" تعداد  رژیم بسته "
                            focused
                            size="small"
                            variant="filled"></TextField>

                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth onChange={(e: any) => setValues({ ...values, firstMultiDietId: e.target.value })}
                            value={values.firstMultiDietId}
                            label=" شناسه رژیم اول بسته "
                            focused
                            size="small"
                            variant="filled"></TextField>
                        <TextField
                            style={{ fontFamily: "IranSans-Light" }}
                            fullWidth onChange={(e: any) => setValues({ ...values, referTimes: e.target.value })}
                            value={values.referTimes}
                            label="    تعداد مراجعه "
                            focused
                            size="small"
                            variant="filled"></TextField>

                        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }}>
                            <Switch
                                checked={values.isActive}
                                onChange={(e: any) => setValues({ ...values, isActive: !values.isActive })}
                                color="primary"
                                name="فعال/غیرفعال کردن رژیم"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <span style={{ color: "#727070" }}>فعال/غیرفعال کردن رژیم</span>
                        </div>

                        <Button
                            style={{ marginTop: "10px" }}
                            color="primary"
                            variant='outlined'
                            type="submit"
                            onClick={(e) => submitEdit(e)}>
                            {isLoading ? <CircularProgress size={20} /> : <span>ثبت</span>}
                            {values.isActive}
                        </Button>
                    </form>
                </div>
                :
                <div></div>
            }


        </div>
    )
}